import { render, staticRenderFns } from "./SeriesExpandedRecetteTile.vue?vue&type=template&id=20c01452&scoped=true&"
import script from "./SeriesExpandedRecetteTile.vue?vue&type=script&lang=js&"
export * from "./SeriesExpandedRecetteTile.vue?vue&type=script&lang=js&"
import style0 from "./SeriesExpandedRecetteTile.vue?vue&type=style&index=0&id=20c01452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c01452",
  null
  
)

component.options.__file = "SeriesExpandedRecetteTile.vue"
export default component.exports